// src/pages/History/20thCentury/ColdWar.jsx
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/20th_Century_-_Cold_War.png';

function HistoryPageColdWar() {
  return (
    <TopicPage
      topicKey="Cold War"
      title="History: Cold War"
      backgroundImage={bg}
      startRoute="/History-Cold-War-Go"
      scrollLabels={[
        "Ideological Divide",
        "Cuban Missile Crisis",
        "Fall of the Berlin Wall",
      ]}
      backRoute="/history-20th-century"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageColdWar;
